<template>
  <div class="addPotentialSafetyHazard">
    <div class="newsDetial-header" v-if="id">
      <div v-if="tabnum == 1">
        <div class="newsDetial-title">隐患问题整改申报</div>
        <blank height="7"> </blank>
        <div class="card-title">
          <div class="state1" v-if="Form.state == 1">审批中</div>
          <div class="state2" v-if="Form.state == 2">已归档</div>
          <div class="state3" v-if="Form.state == 3">退回</div>
          <div class="state4" v-if="Form.state == 4">取消</div>
        </div>
      </div>
      <div v-else>
        <div class="newsDetial-title">
          安全隐患<span v-if="Form.checkType == 0">自查</span>
          <span v-if="Form.checkType == 1">上级检查</span> 整改流程图
        </div>
        <blank height="7"> </blank>
        <a-button
          v-if="Form.state == 2"
          class="detial-top-btn"
          type="primary"
          icon="printer"
          @click="printDDD()"
        >
          打印
        </a-button>
      </div>
      <a-tabs v-model="tabnum" @change="tabClick">
        <a-tab-pane key="1" tab="表单详情" />
        <!-- 草稿未开启审批流不展示跳转审批流按钮 -->
        <a-tab-pane
          key="2"
          tab="表单流程"
          v-if="Form.state > 0 && version == ''"
        />
      </a-tabs>
    </div>
    <div class="newsDetial-header" v-else>
      <div class="newsDetial-title">隐患问题整改申报</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract">
        请按照文本要求添加表单，并提交进行流程审批
      </div>
      <blank height="45"> </blank>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <div class="detial-cont-title">隐患信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item label="隐患级别">
            <a-select
              :disabled="disabled || formStep == 2"
              placeholder="请选择隐患级别"
              class="w300"
              v-model="Form.hiddenDangerLevel"
            >
              <a-select-option :value="1">一般</a-select-option>
              <a-select-option :value="2"> 重大 </a-select-option>
            </a-select>
          </a-descriptions-item>

          <a-descriptions-item>
            <span slot="label">检查类型<span class="required">*</span> </span>
            <a-select
              :disabled="disabled || formStep == 2"
              placeholder="请选择检查类型"
              class="w300"
              v-model="Form.checkType"
            >
              <a-select-option :value="1">上级检查</a-select-option>
              <a-select-option :value="0"> 自查 </a-select-option>
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">上报机构<span class="required">*</span> </span>
            <a-tooltip placement="topLeft" :title="Form.organizationName">
              <div>
                <a-input
                  v-if="id"
                  class="w300"
                  placeholder="请添加"
                  v-model="Form.organizationName"
                  disabled
                />
                <a-select
                  v-else
                  class="w300"
                  placeholder="请选择"
                  v-model="Form.organizationId"
                  :disabled="disabled"
                >
                  <a-select-option
                    v-for="item in organizationUserList"
                    :value="item.organizationId"
                    :key="item.organizationId"
                  >
                    {{ item.organizationname }}</a-select-option
                  >
                </a-select>
              </div>
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">上报人<span class="required">*</span> </span>
            <a-select
              disabled
              placeholder="请添加"
              class="w300"
              v-model="Form.reportPersonId"
            >
              <a-select-option
                v-for="i in queryUserList"
                :value="i.id"
                :key="i.id"
                >{{ i.fullName }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">上报时间<span class="required">*</span> </span>
            <a-date-picker
              :disabled="disabled || formStep == 2"
              class="w300"
              v-model="Form.reportTime"
              :valueFormat="dateFormat"
            />
          </a-descriptions-item>
          <br />
          <a-descriptions-item>
            <span slot="label"
              >隐患问题描述<span class="required">*</span>
            </span>
            <a-input
              :disabled="disabled || formStep == 2"
              class="w500"
              v-model="Form.hiddenDangerDescription"
              type="textarea"
              @change="eightyfive('hiddenDangerDescription', 200)"
              :auto-size="{ minRows: 4, maxRows: 6 }"
            />
          </a-descriptions-item>
        </a-descriptions>
        <div class="problem-cont mb20">
          <div class="problem-title">隐患问题照片</div>
          <blank height="10"> </blank>
          <div class="clearfix">
            <!-- <img :src="imgUrl" alt="" class="problem-img" /> -->
            <template v-for="(i, index) in upfileList">
              <div class="problem-img-cont" :key="index" v-if="i.fileType == 1">
                <img
                  alt="example"
                  :src="fileUrlHOST + 'mongo/kkFile?fileId=' + i.mongoFileId"
                  class="problem-img"
                />
                <div class="problem-img-bgc">
                  <a-icon
                    type="zoom-in"
                    class="problem-img-bgc-icon"
                    @click="lookImg(i.mongoFileId)"
                  />
                  <a-icon
                    @click="removeFiles(index)"
                    type="delete"
                    class="problem-img-bgc-icon ml10"
                    v-if="!disabled && formStep != 2"
                  />
                </div>
              </div>
            </template>
            <a-upload
              action="#"
              list-type="picture-card"
              :file-list="fileList"
              :beforeUpload="beforeUpload"
              @change="handleChange1"
              v-if="!disabled && formStep != 2"
            >
              <div>
                <a-icon type="plus" />
                <div class="ant-upload-text">上传照片</div>
              </div>
            </a-upload>
          </div>
        </div>

        <a-descriptions layout="vertical">
          <a-descriptions-item label="责任人">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.responsibilityPerson"
              :disabled="disabled || formStep == 2"
              @change="eightyfive('responsibilityPerson', 85)"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">整改时段<span class="required">*</span> </span>
            <a-range-picker
              :disabled="disabled || formStep == 2"
              class="w300"
              v-model="timeHorizon"
              :valueFormat="dateFormat"
              :default-value="[
                moment('2015/01/01', dateFormat),
                moment('2015/01/01', dateFormat)
              ]"
            />
          </a-descriptions-item>
          <br />
          <a-descriptions-item label="整改措施">
            <a-input
              :disabled="disabled || formStep == 2"
              class="w500"
              v-model="Form.rectificationMeasures"
              type="textarea"
              :auto-size="{ minRows: 4, maxRows: 6 }"
              @change="eightyfive('rectificationMeasures', 200)"
            />
          </a-descriptions-item>
        </a-descriptions>
        <!-- 第二步骤表单，进入审批流并且currentStep > 1才展示 formStep>1才可修改-->
        <div
          class="personage"
          v-if="tabnum == 1 && Form.state > 0 && currentStep > 1"
        >
          <div class="personage-title">隐患问题整改完成情况</div>
          <div class="personage-cont">
            <a-descriptions
              style="border-bottom: #e9e9e9 1px solid"
              layout="vertical"
            >
              <a-descriptions-item label="整改完成情况描述">
                <a-input
                  :disabled="disabled || formStep == 1"
                  class="w500"
                  v-model="Form.rectificationDescription"
                  type="textarea"
                  :auto-size="{ minRows: 4, maxRows: 6 }"
                />
              </a-descriptions-item>
            </a-descriptions>
            <blank height="16"> </blank>
            <div class="problem-cont mb20">
              <div class="problem-title">上传整改照片</div>
              <blank height="10"> </blank>
              <div class="clearfix">
                <!-- <img :src="imgUrl" alt="" class="problem-img" /> -->
                <template v-for="(i, index) in upfileList">
                  <div
                    class="problem-img-cont"
                    :key="index"
                    v-if="i.fileType == 2"
                  >
                    <img
                      :src="
                        fileUrlHOST + 'mongo/kkFile?fileId=' + i.mongoFileId
                      "
                      alt=""
                      class="problem-img"
                    />
                    <div class="problem-img-bgc">
                      <a-icon
                        type="zoom-in"
                        class="problem-img-bgc-icon"
                        @click="lookImg(i.mongoFileId)"
                      />
                      <a-icon
                        @click="removeFiles(index)"
                        type="delete"
                        class="problem-img-bgc-icon ml10"
                        v-if="!disabled && formStep != 1"
                      />
                    </div>
                  </div>
                </template>
                <a-upload
                  action="#"
                  list-type="picture-card"
                  :file-list="fileList"
                  :beforeUpload="beforeUpload"
                  @change="handleChange2"
                  v-if="!disabled && formStep != 1"
                >
                  <div>
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传照片</div>
                  </div>
                </a-upload>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="detial-cont" v-if="tabnum == 2">
      <div class="detial-cont-title">审批流程图示</div>
      <blank height="1"> </blank>
      <!-- 审批流 表单流程 -->
      <div class="detial-cont-view">
        <keep-alive>
          <approvalChart
            ref="refChart"
            :approvalChartData="approvalChartData"
          ></approvalChart>
        </keep-alive>
      </div>
    </div>
    <div class="detial-cont" v-if="tabnum == 2"></div>
    <appfloor v-if="tabnum == 2"></appfloor>
    <template v-if="tabnum == 1">
      <bottomSuspension>
        <a-button :style="{ marginRight: '20px' }" @click="goback">
          返回
        </a-button>
        <!-- 表单为可编辑状态 显示提交按钮 -->
        <template>
          <div v-if="proQueryParams.isEdit === '0' ? true : false">
            <a-button
              :loading="confirmLoading && Form.draft == 2"
              type="primary"
              class="orange-btn"
              @click="preserveFn('0')"
              :style="{ marginRight: '20px' }"
            >
              保存
            </a-button>
          </div>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="confirmLoading && Form.draft == 1"
            type="primary"
            class="orange-btn"
            @click="preserveFn('1')"
            :style="{ marginRight: '20px' }"
          >
            保存
          </a-button>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            提交
          </a-button>
          <a-button
            v-if="proQueryParams.showApproveBtn === '1'"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            {{ Form.state === 3 ? '提交' : '审批' }}
          </a-button>
        </template>
        <!-- 表单正在审批状态  显示审批按钮 -->
        <div v-if="proQueryParams.showApproveBtn === '1' ? true : false">
          <a-button
            v-if="Form.state === 3 ? true : false"
            type="danger"
            @click="cancelPro('2')"
            :style="{ marginRight: '20px' }"
          >
            删除
          </a-button>
          <!-- <a-button
            v-if="Form.state === 3 ? true : false"
            type="primary"
            @click="cancelPro('1')"
            :style="{ marginRight: '20px' }"
          >
            提交
          </a-button>
          <a-button
            v-if="Form.state === 3 ? false : true"
            @click="approvalPro"
            type="primary"
            :style="{ marginRight: '42px' }"
          >
            审批
          </a-button> -->
        </div>
      </bottomSuspension>
    </template>
    <!-- 审批流审批弹窗 -->
    <approvalSubmission v-model="isActivitiMode"></approvalSubmission>
    <print
      v-model="isPrint"
      v-if="Form.state == 2"
      :id="id"
      mobilePath="/pages/workbench/dangerRectify/details?id="
      skipPageReqFlag="/PotentialSafetyHazardDetial"
    >
      <div class="print-title">北京民政工业总公司隐患问题整改审批表</div>
      <div class="printd-cont">
        <div class="printd-item">
          <a-descriptions bordered size="small">
            <a-descriptions-item label="隐患级别" :span="1.5">
              {{ Form.hiddenDangerLevel == 1 ? '一般' : '重大' }}
            </a-descriptions-item>
            <a-descriptions-item label="检查类型" :span="1.5">
              {{ Form.checkType == 1 ? '上级检查' : '自查' }}
            </a-descriptions-item>
            <a-descriptions-item label="上报机构" :span="3">
              {{ Form.organizationName }}
            </a-descriptions-item>
            <a-descriptions-item label="上报人" :span="1.5">
              {{ Form.reportPersonName }}
            </a-descriptions-item>
            <a-descriptions-item label="上报时间" :span="1.5">
              {{ Form.reportTime }}
            </a-descriptions-item>
            <a-descriptions-item label="隐患问题描述" :span="3">
              {{ Form.hiddenDangerDescription }}
            </a-descriptions-item>
            <a-descriptions-item label="责任人" :span="1.5">
              {{ Form.responsibilityPerson }}
            </a-descriptions-item>
            <a-descriptions-item label="整改时间段" :span="1.5">
              {{ Form.rectificationStartTime }}~
              {{ Form.rectificationEndTime }}
            </a-descriptions-item>
            <a-descriptions-item label="整改措施" :span="3">
              {{ Form.rectificationMeasures }}
            </a-descriptions-item>
            <a-descriptions-item label="整改完成情况描述" :span="3">
              {{ Form.rectificationDescription }}
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div class="printd-item">
          <a-table
            size="small"
            :pagination="false"
            :columns="columns"
            :data-source="formDTOList"
            :row-key="(record) => record.id"
            bordered
          >
          </a-table>
        </div>
      </div>
    </print>
    <!-- 图片放大 -->
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="handleCancel"
      :width="800"
    >
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { saveFile } from '@/http/url.js'
import {
  addHiddenDanger,
  HiddenDangerDetial,
  updateHiddenDanger,
  getHistoryDetial
} from './api/api'
import { getSuffix, formatDateNoDetails } from '@/assets/js/auth'
import moment from 'moment'
import { kkFileUrl, fileUrlHOST } from '@/http/config'
import approvalSubmission from '@/components/approval-submission/index'
import approvalChart from '@/components/approval-chart/index'
import { activitiSubmission } from '@/utils/utils'
export default {
  components: {
    approvalSubmission,
    approvalChart
  },
  data() {
    return {
      fileUrlHOST,
      confirmLoading: false,
      loading: false,
      tabnum: '1', // 1表单页面， 2审批流页面
      Form: {},
      timeHorizon: [], //整改时段
      previewVisible: false,
      previewImage: '',
      fileList: [],
      upfileList: [],
      id: '',
      version: '',
      dateFormat: 'YYYY-MM-DD',
      // 审批流部分
      // disabled: true,
      isActivitiMode: {
        isActivitiShow: false,
        proQueryParams: []
      },
      proQueryParams: [],
      // 审批流部分
      currentStep: 100, //表单显示步骤   100 全显示，1显示第一步，2显示第二部
      formStep: 100, //表单可修改步骤   100 全表单 1 代表第一步骤 2 代表第二步骤
      // 打印部分
      isPrint: false, // 打印弹窗
      columns: [
        {
          title: '审批部门（人）',
          dataIndex: 'dutyOfficerStr',
          key: 'dutyOfficerStr',
          align: 'left'
        },
        {
          title: '审批意见',
          dataIndex: 'fieldValue1',
          key: 'fieldValue1',
          align: 'left'
        },
        {
          title: '审批时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'left'
        }
      ],
      formDTOList: [],
      pIsedit: ''
    }
  },
  computed: {
    ...mapState({
      organizationUserList: (state) => state.app.organizationUserList, // 当前用户可选部门
      queryUserList: (state) => state.app.queryUserList // 用户列表
    }),
    // 获取表单是否可编辑状态  false可编辑  true不可编辑
    disabled: function () {
      if (!this.id) {
        // id不存在  为添加  可编辑
        return false
      } else {
        this.proQueryParams = this.$route.query
        if (this.proQueryParams.isEdit) {
          if (
            this.proQueryParams.isEdit === '100' ||
            this.proQueryParams.isEdit === '1'
          ) {
            return true
          } else {
            return false
          }
        } else if (this.Form.state == 1 || this.Form.state == 2) {
          //审批状态和归档状态  不可编辑
          return true
        } else {
          // 草稿箱或退回状态  可编辑
          return false
        }
      }
    }
  },
  created() {
    this.getorganizationUserList()
    this.getqueryUserList()
    this.id = this.$route.query.id ? this.$route.query.id : ''
    this.version = this.$route.query.version ? this.$route.query.version : ''
    this.currentStep = this.$route.query.currentStep
      ? parseInt(this.$route.query.currentStep)
      : 100
    this.formStep = this.$route.query.formStep
      ? parseInt(this.$route.query.formStep)
      : 100
    if (this.id) {
      if (this.version) {
        this.getHistoryDetialFn()
      } else {
        this.HiddenDangerDetialFn()
      }
    } else {
      this.Form.reportPersonId = this.$store.state.app.userInfo.id
      let date = new Date()
      this.$set(this.Form, 'reportTime', formatDateNoDetails(date))
      this.$set(
        this.Form,
        'organizationId',
        this.$store.state.app.organizationId
      )
    }
  },
  methods: {
    // 输入框限制85
    eightyfive(v, maxNum) {
      if (this.Form[v].length > maxNum) {
        this.Form[v] = this.Form[v].substring(0, maxNum)
        this.$message.destroy()
        this.$message.warning('只能输入' + maxNum + '个字')
      }
    },
    printDDD() {
      this.formDTOList = this.$refs.refChart.getHighLine.formDTOList
      this.isPrint = true
      document.title =
        '隐患问题整改-' +
        this.Form.responsibilityPerson +
        this.$printFormatDate(new Date())
    },
    getHistoryDetialFn() {
      getHistoryDetial({ id: this.id, version: this.version }).then((res) => {
        if (res.data.code == 0) {
          this.Form = res.data.data
          this.upfileList = this.Form.hdFile
          this.timeHorizon[0] = this.Form.rectificationStartTime
          this.timeHorizon[1] = this.Form.rectificationEndTime
        }
      })
    },
    HiddenDangerDetialFn() {
      HiddenDangerDetial(this.id).then((res) => {
        if (res.data.code == 0) {
          this.Form = res.data.data
          this.upfileList = this.Form.hdFile
          this.timeHorizon[0] = this.Form.rectificationStartTime
          this.timeHorizon[1] = this.Form.rectificationEndTime
          // 多个对象合并合并多个
          let processInstanceId = {
            processInstanceId: res.data.data.processInstanceId,
            detailsData: res.data.data
          }
          Object.assign(this.proQueryParams, processInstanceId)
        }
      })
    },
    // 审批流取消
    cancelPro(key) {
      switch (key) {
        case '1':
          // 提交
          this.$confirm({
            title: '您是否提交?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '1', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break
        case '2':
          // 取消
          this.$confirm({
            title: '您是否删除?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '2', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break

        default:
          break
      }
    },
    // 切换审批流 表单流程
    tabClick(key) {
      if (key == 2) {
        this.approvalChartData = this.proQueryParams
      } else {
        this.HiddenDangerDetialFn()
      }
    },
    // 固定资产 申请模块 工作流审批
    approvalPro() {
      this.isActivitiMode = {
        isActivitiShow: true,
        proQueryParams: this.proQueryParams
      }
    },
    moment,
    ...mapActions(['getorganizationUserList', 'getqueryUserList']),
    handleCancel() {
      this.previewVisible = false
    },
    lookImg(mongoFileId) {
      this.previewImage = fileUrlHOST + 'mongo/kkFile?fileId=' + mongoFileId
      this.previewVisible = true
    },

    // 移除
    removeFiles(index) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          this.upfileList.splice(index, 1)
          this.$message.success('删除成功')
        }
      })
    },
    preserveFn(type) {
      if (type === '0') {
        // 自定义保存判断 1 = 仅保存
        this.pIsedit = '1'
        this.Form.draft = 2
      } else {
        this.pIsedit = '2'
        this.Form.draft = 1
      }
      this.saveFormFn('保存')
    },

    submitFn() {
      this.Form.draft = 2
      this.saveFormFn('添加')
    },
    saveFormFn(type) {
      if (this.Form.checkType != 0 && this.Form.checkType != 1) {
        this.$message.error('请选择检查类型')
        return
      }
      if (!this.Form.organizationId) {
        this.$message.error('请添加上报机构')
        return false
      }
      if (!this.Form.reportTime) {
        this.$message.error('请选择上报时间')
        return
      }
      if (!this.Form.hiddenDangerDescription) {
        this.$message.error('请添加隐患问题描述')
        return
      }
      if (this.timeHorizon.length > 0) {
        //选择了时间范围
        this.Form.rectificationStartTime = this.timeHorizon[0]
        this.Form.rectificationEndTime = this.timeHorizon[1]
      }
      this.confirmLoading = true
      this.Form.hdFile = this.upfileList
      this.Form.appId = this.$route.meta.appId
      this.Form.skipPageReqFlag = '/PotentialSafetyHazardDetial'
      if (this.pIsedit === '') {
        this.loading = true
      } else {
        this.confirmLoading = true
      }
      if (this.id) {
        // 表单步骤：formStep: 100 全表单 1 代表第一步骤 2 代表第二步骤
        this.Form.formStep = this.formStep
        updateHiddenDanger(this.Form).then((res) => {
          if (res.data.code == 0) {
            if (this.pIsedit === '1') {
              this.$message.success('保存成功')
              this.pIsedit = ''
            } else {
              if (this.Form.state > 0) {
                this.HiddenDangerDetialFn()
                // 合并 保存+审批流操作
                if (
                  this.proQueryParams.showApproveBtn === '1' &&
                  this.Form.state != '3'
                ) {
                  this.approvalPro()
                } else {
                  this.cancelPro('1')
                }
                // this.$message.success('修改成功')
                // 合并 保存+审批流操作
              } else {
                if (this.Form.draft == 2) {
                  this.$message.success('提交成功')
                  this.goback()
                } else {
                  this.$message.success('保存成功')
                }
              }
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      } else {
        //获取部门名称
        let organizationName = ''
        this.organizationUserList.forEach((item, index) => {
          if (item.organizationId == this.Form.organizationId) {
            organizationName = item.organizationname
          }
        })
        this.Form.organizationName = organizationName
        addHiddenDanger(this.Form).then((res) => {
          if (res.data.code == 0) {
            this.$message.success(type + '成功')
            if (this.Form.draft == 2) {
              this.goback()
            } else {
              //首次添加
              this.id = res.data.data
              this.HiddenDangerDetialFn()
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      }
    },
    handleChange1(file) {
      if (file.file.size > 10485760) {
        // 大于10M 拦截
        this.$message.error('上传文件不得大于10M！')
      } else {
        let isImg = this.normFile(file)
        if (isImg) {
          // 是图片
          this.saveFileFn(file.file, 1)
        } else {
          this.$message.error('请上传图片文件！')
        }
      }
    },
    handleChange2(file) {
      if (file.file.size > 10485760) {
        // 大于10M 拦截
        this.$message.error('上传文件不得大于10M！')
      } else {
        let isImg = this.normFile(file)
        if (isImg) {
          // 是图片
          this.saveFileFn(file.file, 2)
        } else {
          this.$message.error('请上传图片文件！')
        }
      }
    },
    normFile(e) {
      // 检查文件类型类型
      // 只能上传图片格式
      const isJPG = e.file.type === 'image/jpeg'
      const isPNG = e.file.type === 'image/png'
      const isBMP = e.file.type === 'image/bmp'
      const isGIF = e.file.type === 'image/gif'
      const isWEBP = e.file.type === 'image/webp'
      const isPic = isJPG || isPNG || isBMP || isGIF || isWEBP
      if (!isPic) {
        return false
      } else {
        return true
      }
    },

    beforeUpload() {
      return false
    },
    saveFileFn(file, fileType) {
      const formDataChildren = new FormData()
      formDataChildren.append('file', file)
      this.$message.loading('上传中···', 0)
      saveFile(formDataChildren).then((res) => {
        if (res.data.code == 0) {
          this.$message.destroy()
          this.$message.success('上传成功')
          let fileData = {}
          let SuffixArray = getSuffix(file.name)
          fileData.fileName = SuffixArray[1]
          fileData.fileFormat = SuffixArray[0]
          fileData.mongoFileId = res.data.data
          fileData.fileType = fileType
          this.upfileList.push(fileData)
        } else {
          this.$message.error('上传失败')
        }
      })
    },
    goback() {
      this.$router.push('/PotentialSafetyHazard')
    }
  }
}
</script>

<style lang="scss" scoped>
.addPotentialSafetyHazard {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .problem-cont {
        .problem-title {
          height: 24px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 16px;
        }
        .clearfix {
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          flex-wrap: wrap;

          .problem-img-cont {
            width: 100px;
            height: 100px;
            margin-right: 30px;
            margin-bottom: 30px;
            position: relative;
            .problem-img {
              width: 100px;
              height: 100px;
            }
            .problem-img-bgc {
              opacity: 0;
              position: absolute;
              top: 0;
              left: 0;
              width: 100px;
              height: 100px;
              background-color: rgba(0, 0, 0, 0.4);
              display: flex;
              align-items: center;
              justify-content: center;
              .problem-img-bgc-icon {
                font-size: 18px;
                color: #fff;
                cursor: pointer;
              }
            }
          }
          .problem-img-cont:hover {
            width: 100px;
            height: 100px;
            margin-right: 30px;
            margin-bottom: 30px;
            position: relative;
            .problem-img {
              width: 100px;
              height: 100px;
            }
            .problem-img-bgc {
              opacity: 1;
              position: absolute;
              top: 0;
              left: 0;
              width: 100px;
              height: 100px;
              background-color: rgba(0, 0, 0, 0.4);
              display: flex;
              align-items: center;
              justify-content: center;
              .problem-img-bgc-icon {
                font-size: 18px;
                color: #fff;
                cursor: pointer;
              }
            }
          }
        }
      }
      .personage {
        // height: 360px;
        border: #e9e9e9 solid 1px;
        border-radius: 4px;
        .personage-title {
          padding-left: 24px;
          height: 44px;
          color: rgba(0, 0, 0, 0.85);
          background-color: rgba(250, 250, 250, 1);
          border-bottom: #e9e9e9 solid 1px;
          border-radius: 4px;
          font-size: 14px;
          line-height: 44px;
        }
        .personage-cont {
          padding: 16px 24px 0 24px;
          .conference {
            min-width: 1000px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .name-suffix {
              width: 178px;
              color: rgba(166, 166, 166, 1);
              font-size: 14px;
              text-align: left;
            }
          }
        }
      }
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .detial-bottom {
    height: 56px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
// 打印内容不能嵌套写样式

.print-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
}
</style>
<style lang="scss">
.clearfix {
  .ant-upload-picture-card-wrapper {
    width: 100px;
  }
}
</style>

<!-- 隐患问题整改 -->
<style scoped src="@/assets/css/printModal.css"></style>



// WEBPACK FOOTER //
// src/views/PotentialSafetyHazard/detial.vue